import {Titlebar} from "../../layouts/Content";

const SettingsSystem = () => {
	return(
		<>
			<Titlebar title="System Settings" />
		</>
	)
};
export default SettingsSystem;